/// <reference types="./middleware.d.mts" />
import * as $auth0 from "../../auth0_client/auth0/client/user.mjs";
import * as $local_storage from "../../ds/web/browser/local_storage.mjs";
import * as $promise from "../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $dynamic from "../../gleam_stdlib/gleam/dynamic.mjs";
import * as $function from "../../gleam_stdlib/gleam/function.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $effect from "../../lustre/lustre/effect.mjs";
import * as $state from "../data/model/state.mjs";
import * as $msg from "../data/msg.mjs";
import * as $route from "../data/route.mjs";
import * as $scaffold from "../frontend/browser/scaffold.mjs";
import { Ok, toList } from "../gleam.mjs";

export function require_access_token(next) {
  let $ = $local_storage.get_item("access-token");
  if ($ instanceof Ok) {
    let access_token = $[0];
    return next(access_token);
  } else {
    return $effect.none();
  }
}

export function require_permission(state, permission, next) {
  let $ = $list.contains(state.permissions, permission);
  if ($) {
    return next();
  } else {
    return $effect.none();
  }
}

export function require_org_id(state, next) {
  let org_id = $option.then$(state.user, $auth0.org_id);
  if (org_id instanceof $option.Some) {
    let org_id$1 = org_id[0];
    return next(org_id$1);
  } else {
    return $effect.none();
  }
}

export function require_user_id(state, next) {
  let user = $option.map(state.user, $auth0.id);
  if (user instanceof $option.Some) {
    let user_id = user[0];
    return next(user_id);
  } else {
    return $effect.none();
  }
}

export function from_promise(promise, next) {
  return $effect.from(
    (dispatch) => {
      return $function.tap(
        undefined,
        (_) => {
          return $promise.map(
            promise,
            (content) => { return next(dispatch, content); },
          );
        },
      );
    },
  );
}

export function restore_cursor(previous_offset) {
  return $effect.before_paint(
    (_, _1) => {
      return $function.tap(
        undefined,
        (_) => { let $ = $scaffold.restore_cursor_position(previous_offset);
          
          return $; },
      );
    },
  );
}

export function restore_cursor_position(next) {
  let $ = next();
  let data = $[0];
  let next$1 = $[1];
  let $1 = $scaffold.active_element_id();
  if ($1 instanceof Ok) {
    let $2 = $1[0][0];
    if ($2.startsWith("question")) {
      let previous_offset = $1[0][1];
      let restore = restore_cursor(previous_offset);
      return [data, $effect.batch(toList([next$1, restore]))];
    } else if ($2 === "input-proposal-name") {
      return [data, $effect.none()];
    } else {
      return [data, next$1];
    }
  } else {
    return [data, next$1];
  }
}

export function require_slack_login(state, next) {
  let $ = state.route;
  if ($ instanceof $route.SlackLogin) {
    let team_id = $.team_id;
    let user_id = $.user_id;
    return next(team_id, user_id);
  } else {
    return $effect.none();
  }
}
